// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file authenticator_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Authenticator, AuthenticatorBlock, AuthenticatorCreationData } from "./authenticator_pb";
import { file_authenticator } from "./authenticator_pb";
import type { ProfileRegenerateData } from "./profile_pb";
import { file_profile } from "./profile_pb";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file authenticator_service.proto.
 */
export const file_authenticator_service: GenFile = /*@__PURE__*/
  fileDesc("ChthdXRoZW50aWNhdG9yX3NlcnZpY2UucHJvdG8SBmRvbWFpbiL5AQobTW9kaWZ5QXV0aGVudGljYXRvcnNSZXF1ZXN0EkMKGGNyZWF0ZV9hdXRoZW50aWNhdG9yX29wcxgBIAMoCzIhLmRvbWFpbi5BdXRoZW50aWNhdG9yQ3JlYXRpb25EYXRhEiAKGGRlbGV0ZV9hdXRoZW50aWNhdG9yX2lkcxgCIAMoCRIbChNhdXRoZW50aWNhdG9yX2Jsb2NrGAMgASgMEiUKHWF1dGhlbnRpY2F0b3JfYmxvY2tfc2lnbmF0dXJlGAQgASgMEi8KCHByb2ZpbGVzGAUgAygLMh0uZG9tYWluLlByb2ZpbGVSZWdlbmVyYXRlRGF0YSJiChxNb2RpZnlBdXRoZW50aWNhdG9yc1Jlc3BvbnNlEicKC3N5bmNfdXBkYXRlGAEgASgLMhIuZG9tYWluLlN5bmNVcGRhdGUSGQoRYXV0aGVudGljYXRvcl9pZHMYAiADKAkiRAoZTGlzdEF1dGhlbnRpY2F0b3JzUmVxdWVzdBInCh9sYXRlc3RfYXV0aGVudGljYXRvcl9ibG9ja19oYXNoGAEgASgMIoUBChpMaXN0QXV0aGVudGljYXRvcnNSZXNwb25zZRItCg5hdXRoZW50aWNhdG9ycxgBIAMoCzIVLmRvbWFpbi5BdXRoZW50aWNhdG9yEjgKFGF1dGhlbnRpY2F0b3JfYmxvY2tzGAIgAygLMhouZG9tYWluLkF1dGhlbnRpY2F0b3JCbG9jayJhCiZDcmVhdGVJbml0aWFsQXV0aGVudGljYXRvckJsb2NrUmVxdWVzdBI3ChNhdXRoZW50aWNhdG9yX2Jsb2NrGAEgASgLMhouZG9tYWluLkF1dGhlbnRpY2F0b3JCbG9jayJSCidDcmVhdGVJbml0aWFsQXV0aGVudGljYXRvckJsb2NrUmVzcG9uc2USJwoLc3luY191cGRhdGUYASABKAsyEi5kb21haW4uU3luY1VwZGF0ZSIXChVTZXREZXZpY2VUb2tlblJlcXVlc3QiGAoWU2V0RGV2aWNlVG9rZW5SZXNwb25zZTKYAwoUQXV0aGVudGljYXRvclNlcnZpY2USVQoGTW9kaWZ5EiMuZG9tYWluLk1vZGlmeUF1dGhlbnRpY2F0b3JzUmVxdWVzdBokLmRvbWFpbi5Nb2RpZnlBdXRoZW50aWNhdG9yc1Jlc3BvbnNlIgASTwoETGlzdBIhLmRvbWFpbi5MaXN0QXV0aGVudGljYXRvcnNSZXF1ZXN0GiIuZG9tYWluLkxpc3RBdXRoZW50aWNhdG9yc1Jlc3BvbnNlIgAShAEKH0NyZWF0ZUluaXRpYWxBdXRoZW50aWNhdG9yQmxvY2sSLi5kb21haW4uQ3JlYXRlSW5pdGlhbEF1dGhlbnRpY2F0b3JCbG9ja1JlcXVlc3QaLy5kb21haW4uQ3JlYXRlSW5pdGlhbEF1dGhlbnRpY2F0b3JCbG9ja1Jlc3BvbnNlIgASUQoOU2V0RGV2aWNlVG9rZW4SHS5kb21haW4uU2V0RGV2aWNlVG9rZW5SZXF1ZXN0Gh4uZG9tYWluLlNldERldmljZVRva2VuUmVzcG9uc2UiAEIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM", [file_authenticator, file_profile, file_sync_update]);

/**
 * @generated from message domain.ModifyAuthenticatorsRequest
 */
export type ModifyAuthenticatorsRequest = Message<"domain.ModifyAuthenticatorsRequest"> & {
  /**
   * @generated from field: repeated domain.AuthenticatorCreationData create_authenticator_ops = 1;
   */
  createAuthenticatorOps: AuthenticatorCreationData[];

  /**
   * @generated from field: repeated string delete_authenticator_ids = 2;
   */
  deleteAuthenticatorIds: string[];

  /**
   * @generated from field: bytes authenticator_block = 3;
   */
  authenticatorBlock: Uint8Array;

  /**
   * @generated from field: bytes authenticator_block_signature = 4;
   */
  authenticatorBlockSignature: Uint8Array;

  /**
   * must be set if any authenticator is removed
   *
   * @generated from field: repeated domain.ProfileRegenerateData profiles = 5;
   */
  profiles: ProfileRegenerateData[];
};

/**
 * Describes the message domain.ModifyAuthenticatorsRequest.
 * Use `create(ModifyAuthenticatorsRequestSchema)` to create a new message.
 */
export const ModifyAuthenticatorsRequestSchema: GenMessage<ModifyAuthenticatorsRequest> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 0);

/**
 * @generated from message domain.ModifyAuthenticatorsResponse
 */
export type ModifyAuthenticatorsResponse = Message<"domain.ModifyAuthenticatorsResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: repeated string authenticator_ids = 2;
   */
  authenticatorIds: string[];
};

/**
 * Describes the message domain.ModifyAuthenticatorsResponse.
 * Use `create(ModifyAuthenticatorsResponseSchema)` to create a new message.
 */
export const ModifyAuthenticatorsResponseSchema: GenMessage<ModifyAuthenticatorsResponse> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 1);

/**
 * @generated from message domain.ListAuthenticatorsRequest
 */
export type ListAuthenticatorsRequest = Message<"domain.ListAuthenticatorsRequest"> & {
  /**
   * @generated from field: bytes latest_authenticator_block_hash = 1;
   */
  latestAuthenticatorBlockHash: Uint8Array;
};

/**
 * Describes the message domain.ListAuthenticatorsRequest.
 * Use `create(ListAuthenticatorsRequestSchema)` to create a new message.
 */
export const ListAuthenticatorsRequestSchema: GenMessage<ListAuthenticatorsRequest> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 2);

/**
 * @generated from message domain.ListAuthenticatorsResponse
 */
export type ListAuthenticatorsResponse = Message<"domain.ListAuthenticatorsResponse"> & {
  /**
   * @generated from field: repeated domain.Authenticator authenticators = 1;
   */
  authenticators: Authenticator[];

  /**
   * @generated from field: repeated domain.AuthenticatorBlock authenticator_blocks = 2;
   */
  authenticatorBlocks: AuthenticatorBlock[];
};

/**
 * Describes the message domain.ListAuthenticatorsResponse.
 * Use `create(ListAuthenticatorsResponseSchema)` to create a new message.
 */
export const ListAuthenticatorsResponseSchema: GenMessage<ListAuthenticatorsResponse> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 3);

/**
 * @generated from message domain.CreateInitialAuthenticatorBlockRequest
 */
export type CreateInitialAuthenticatorBlockRequest = Message<"domain.CreateInitialAuthenticatorBlockRequest"> & {
  /**
   * @generated from field: domain.AuthenticatorBlock authenticator_block = 1;
   */
  authenticatorBlock?: AuthenticatorBlock | undefined;
};

/**
 * Describes the message domain.CreateInitialAuthenticatorBlockRequest.
 * Use `create(CreateInitialAuthenticatorBlockRequestSchema)` to create a new message.
 */
export const CreateInitialAuthenticatorBlockRequestSchema: GenMessage<CreateInitialAuthenticatorBlockRequest> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 4);

/**
 * @generated from message domain.CreateInitialAuthenticatorBlockResponse
 */
export type CreateInitialAuthenticatorBlockResponse = Message<"domain.CreateInitialAuthenticatorBlockResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.CreateInitialAuthenticatorBlockResponse.
 * Use `create(CreateInitialAuthenticatorBlockResponseSchema)` to create a new message.
 */
export const CreateInitialAuthenticatorBlockResponseSchema: GenMessage<CreateInitialAuthenticatorBlockResponse> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 5);

/**
 * empty
 *
 * @generated from message domain.SetDeviceTokenRequest
 */
export type SetDeviceTokenRequest = Message<"domain.SetDeviceTokenRequest"> & {
};

/**
 * Describes the message domain.SetDeviceTokenRequest.
 * Use `create(SetDeviceTokenRequestSchema)` to create a new message.
 */
export const SetDeviceTokenRequestSchema: GenMessage<SetDeviceTokenRequest> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 6);

/**
 * empty
 *
 * @generated from message domain.SetDeviceTokenResponse
 */
export type SetDeviceTokenResponse = Message<"domain.SetDeviceTokenResponse"> & {
};

/**
 * Describes the message domain.SetDeviceTokenResponse.
 * Use `create(SetDeviceTokenResponseSchema)` to create a new message.
 */
export const SetDeviceTokenResponseSchema: GenMessage<SetDeviceTokenResponse> = /*@__PURE__*/
  messageDesc(file_authenticator_service, 7);

/**
 * @generated from service domain.AuthenticatorService
 */
export const AuthenticatorService: GenService<{
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - AuthenticatorBlockOutOfSync (40100): the authenticator blocks parent hash does not match the latest authenticator block
   * - AuthenticatorNotFound (40400): authenticator not found
   * - MissingAuthenticatorBlock (40430): the request is lacking a follow-up authenticator block
   * - VaultNotFound (50400): vault not found
   * - VaultOutOfSync (50100): latest_commit_id does not match
   * - EmptyCommit (50200): commit blob is empty
   * - MissingLock (50410): a lock is missing for regneration or no keks were provided for a new authenticator
   * - MissingVault (50420): VaultRegenerateData is missing for a vault
   * - WebauthnValidateError (80400)
   * - WebauthnDataError (80401)
   * - WebauthnRequestNotFound (80402)
   * - MissingWebauthnCredential (80404)
   * - BadRequest (10400)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AuthenticatorService.Modify
   */
  modify: {
    methodKind: "unary";
    input: typeof ModifyAuthenticatorsRequestSchema;
    output: typeof ModifyAuthenticatorsResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - AuthenticatorBlockNotFound (40440): the authenticator block with given hash was not found or belongs to another user
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AuthenticatorService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListAuthenticatorsRequestSchema;
    output: typeof ListAuthenticatorsResponseSchema;
  },
  /**
   * TODO: deprecate and later remove this endpoint once migration to authenticator blocks is completed
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - AuthenticatorBlockExists (40450): the account already has an authenticator block
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.AuthenticatorService.CreateInitialAuthenticatorBlock
   */
  createInitialAuthenticatorBlock: {
    methodKind: "unary";
    input: typeof CreateInitialAuthenticatorBlockRequestSchema;
    output: typeof CreateInitialAuthenticatorBlockResponseSchema;
  },
  /**
   * DEPRECATED
   * errors:
   * - ClientOutdated (10426)
   *
   * @generated from rpc domain.AuthenticatorService.SetDeviceToken
   */
  setDeviceToken: {
    methodKind: "unary";
    input: typeof SetDeviceTokenRequestSchema;
    output: typeof SetDeviceTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_authenticator_service, 0);

